import httpClient from 'api/httpClient';

function trackTime(
  dataRoomId: string,
  nodeId: string,
  pageIndex: number,
  numberOfSecondsSpent: number,
  version?: number,
) {
  return httpClient.post(
    `data-room-node-reports/data-rooms/${dataRoomId}/data-room-nodes/${nodeId}/track-time`,
    { pageIndex, numberOfSecondsSpent, version },
  );
}

export default {
  trackTime,
};
